const PC_PANEL_WIDTH = 320;
const SP_PANEL_WIDTH = 160;

export { PC_PANEL_WIDTH, SP_PANEL_WIDTH };
